import React, { useRef, useEffect, memo } from "react";

// vpoint: Vector3
export const Point = memo(({ vpoint, color, size }) => {
  const ref = useRef();
  
  useEffect(() => {
    if(ref.current && vpoint){
      ref.current.position.set(vpoint.x, vpoint.y, vpoint.z);
    }
  }, [vpoint]);

  return (
    <mesh renderOrder={1} ref={ref}>
      <sphereGeometry attach="geometry" args={[size, 16, 16]}/>
      <meshBasicMaterial attach="material" color={color} depthTest={false} />
    </mesh>
  );
});

// vpoints: [Vector3]
export const Points = memo(({ vpoints, color, size }) => {
  var objects = [];
  vpoints.forEach((v, i) => {
    if(v != null){
      objects.push(
        <Point key={i} vpoint={v} color={color} size={size}/>
      );
    }
  });

  return objects.length !== 0 ? (
    <React.Fragment>{objects}</React.Fragment>
  ) : null;
});
